export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_14.0d60f143.jpg";